import OrganizationCardData from './OrganizationCardData'
import OrganizationCardAnalytics from './OrganizationCardAnalytics'

function OrganizationCardWidget({ setSelectedOptions, selectedOptions }) {
    return (
        <div className="min-w-[408px] max-w-[408px] h-full bg-white rounded-[24px] ">
            <OrganizationCardData selectedOptions={selectedOptions} />
            <OrganizationCardAnalytics setSelectedOptions={setSelectedOptions} selectedOptions={selectedOptions} />
        </div>
    )
}

export default OrganizationCardWidget
